@if (!itemQuestions?.length) {
  <div class="question-pull" [id]="'specified-items-accordion'">
    @for (item of enteredItems; track item; let i = $index; let last = $last) {
      <div class="card card--freeform">
        <a [href]="'#' + (item?.description_1 ? 'drop-accordion' : 'add-item') + '-' + (i +1)"
          class="card-title"
          data-toggle="collapse" aria-expanded="false" [class.collapsed]="item?.description_1 || !last">
          <div class="card-title__text">
            @if (showIcon) {
              <svg class="icon icon--lg">
                <use [attr.xlink:href]="icon"></use>
              </svg>
            }
            <div class="card-title__text-wrap">
              <h4>{{item?.description_1 ? item?.description_1 : 'Add ' + question?.question_prompt}}</h4>
              @if (item?.description_2) {
                <p>{{questionService?.accounting?.formatMoney(item?.description_2)}}</p>
              }
            </div>
          </div>
          @if (showPremium) {
            <div class="card-title__cost is-active">
              <p><strong>{{questionService?.accounting?.formatMoney(item?.premium)}}</strong>
            /{{item?.frequency ? item?.frequency : questionService?.currency?.display_freq}}</p>
          </div>
        }
        <div class="card-title__caret">
          <svg class="icon">
            <use xlink:href="#dropdown"></use>
          </svg>
        </div>
      </a>
      <div class="card-body collapse"
        [id]="(item?.description_1 ? 'drop-accordion' : 'add-item') + '-' + (i +1)"
        [attr.data-parent]="'#specified-items-accordion'"
        [class.show]="!item?.description_1 || last">
        <div class="card__content">
          @for (itemQuestion of item?.questions; track itemQuestion; let questionIndex = $index) {
            <app-question-controller
              [question]="itemQuestion"
              [controlCssClass]="'ui-front'"
              [showLabel]="true"
              (questionAnswer)="onInputChange($event, questionIndex, i)">
            </app-question-controller>
          }
          @if (showRemove) {
            <div class="card__tray">
              <div class="card__actions">
                <a href="javascript:;" (click)="removeItem(i)" class="text-link">Remove</a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <!-- /card -->
</div>
}

@if (itemQuestions?.length) {
  @for (itemQuestion of itemQuestions; track itemQuestion; let questionIndex = $index; let last = $last) {
    <app-question-controller
      [question]="itemQuestion"
      [controlCssClass]="'ui-front' + (editCardMarginBottom && !last) ? ' mb-20' : ''"
      [showLabelQuestionCopy]="true"
      [showLabel]="true"
      (questionAnswer)="onInputChange($event, questionIndex, 1)">
    </app-question-controller>
  }
}
